import { StartDayFromSchedule } from 'app/constants/configuration/startDayFromSchedule'

export const getStartDayFromScheduleName = (
  startDayFromSchedule: StartDayFromSchedule,
  translate: (string) => string,
): string => {
  const text: string = StartDayFromSchedule[startDayFromSchedule]
  return translate(`startDayFromSchedule.${text}`)
}
